import { type ReceiptFormat } from "~/types/events";
import {
  type Country,
  type Currency,
  type Language,
  type Locale,
  type Timezone
} from "~/api/tills/types";

export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;

export const MINUTE = 60;

export const DEFAULT_COUNTDOWN_SECONDS = 30;

export const DEFAULT_COUNTDOWN_MS = DEFAULT_COUNTDOWN_SECONDS * 1000;

export const DEFAULT_LANGUAGE: Language = "en";
export const DEFAULT_LOCALE: Locale = "da-DK";
export const DEFAULT_CURRENCY: Currency = "DKK";
export const DEFAULT_TIMEZONE: Timezone = "Europe/Copenhagen";
export const DEFAULT_COUNTRY: Country = "DK";

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const FREEDOMPAY_RECEIPT_FORMAT: Partial<
  Record<Country, ReceiptFormat>
> = {
  US: "US",
  CA: "CA",
  GB: "UK",
  FR: "FRANCE"
};

export const TRANSACTION_CODE = {
  SALE: "S",
  REFUND: "R"
};
